/** DTO и типы уведомлений — зеркалят контракт бэка (см. docs/notifications). */

export const NotificationTypes = {
  DepositStatusChanged: "deposit.status_changed",
  EventRegistrationRegistered: "event.registration_registered",
  EventRegistrationPending: "event.registration_pending",
  EventRegistrationApproved: "event.registration_approved",
  EventRegistrationRejected: "event.registration_rejected",
} as const

export type KnownNotificationType = (typeof NotificationTypes)[keyof typeof NotificationTypes]

/** Бэк может добавлять новые типы обратно-совместимо — принимаем любую строку. */
export type NotificationType = KnownNotificationType | (string & {})

/** Числовой enum с бэка: 0=Info, 1=Success, 2=Warning, 3=Error. */
export const NotificationSeverity = {
  Info: 0,
  Success: 1,
  Warning: 2,
  Error: 3,
} as const

export type NotificationSeverity = (typeof NotificationSeverity)[keyof typeof NotificationSeverity]

export const SEVERITY_ICON: Record<NotificationSeverity, string> = {
  0: "ri-information-line",
  1: "ri-checkbox-circle-line",
  2: "ri-alert-line",
  3: "ri-error-warning-line",
}

export type NotificationLink = {
  type?: string
  id?: string
  registrationId?: string
  [key: string]: unknown
}

export type NotificationData = {
  args?: string[]
  link?: NotificationLink
  [key: string]: unknown
}

export type NotificationDto = {
  id: string
  eventId: number
  type: NotificationType
  title: string
  body: string
  data?: NotificationData | null
  severity: NotificationSeverity
  isRead: boolean
  createdAt: string
  readAt: string | null
}

/** ABP PagedResultDto. */
export type NotificationListResponse = {
  totalCount: number
  items: NotificationDto[]
}

export type GetNotificationListInput = {
  isRead?: boolean
  type?: string
  fromDate?: string
  skipCount?: number
  maxResultCount?: number
}

export type UnreadCountDto = {
  count: number
}

export type NotificationPreferenceDto = {
  type: string
  inApp: boolean
  email: boolean
}

export type UpdateNotificationPreferenceDto = {
  inApp: boolean
  email: boolean
}
